import React from "react";
import { object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import "./heroImage.m.css";

const HeroImage = ({ story = {}, config = "", width = 150 }) => {
  const alternateImage = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], null);
  const heroImage = story["hero-image-s3-key"];
  let imageUrlObj = {};
  if (alternateImage) {
    imageUrlObj = { image: `https://${config["cdn-image"]}/${alternateImage}`, type: "alternate-image" };
  } else if (heroImage) {
    imageUrlObj = { image: `https://${config["cdn-image"]}/${heroImage}`, type: "hero-image" };
  }

  return (
    <Link href={`/${story.slug}`}>
      <div styleName="figure">
        {imageUrlObj && imageUrlObj.image ? (
          <img
            src={`${imageUrlObj.image}?w=${width}&auto=format%2Ccompress&fmt=webp`}
            alt={story.headline}
            className={imageUrlObj.type}
          />
        ) : (
          <img
            src="https://assets.prothomalo.com/prothomalo/assets/default-9cdca736f114c54b34fe.svg"
            alt={story.headline}
            className="default-image"
          />
        )}
      </div>
    </Link>
  );
};

HeroImage.propTypes = {
  story: object,
  config: object,
  width: array
};

const mapStateToProps = state => {
  return {
    config: get(state, ["qt", "config"], {})
  };
};

export default connect(mapStateToProps)(HeroImage);
